import { Button, Card, Divider, Grid } from "@material-ui/core";
import * as React from "react";
import { FileField, FileInput, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { SectionTitle } from "../../../src/Components/SectionTitle";
import { Separator } from "../../../src/Components/Separator";
import CustomLinearProgress from "../../../src/Components/Progress/LinearProgress";
import { useAppDataProvider } from "../../../src/dataprovider";
import XLSX from "xlsx";
import { ExcelTemplate } from "./Constant/Source";
import { CloudDownload } from "@material-ui/icons";
export const BulkUpload = props => {
  const notify = useNotify();
  const dataProvider = useAppDataProvider();
  const [loading, setLoading] = React.useState(false);
  const headers = [
    "Pn",
    "Description",
    "Spt",
    "LimitStatus",
    "LimitNote",
    "OperationPlace",
    "OperationPlaceCode",
    "Remarks",
  ];
  const headerValidate = csvHeader => {
    const result = headers.filter(x => !csvHeader.includes(x.toLowerCase()));
    return csvHeader.length !== headers.length || result?.length > 0;
  };

  const handleFileChange = fileObj => {
    setLoading(true);
    let file: any = fileObj[0];
    const reader = new FileReader();
    if (file?.path?.includes?.(".xlsx")) {
      reader.onload = (evt: any) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 as any } as any);
        csvFileToArray(data);
      };
      reader.readAsBinaryString(file);
    } else if (file?.path?.includes?.(".csv")) {
      const reader = new FileReader();
      reader.onload = function (e: any) {
        const text = e.target.result;
        var workbook = XLSX.read(text);
        csvFileToArray(text);
      };
      reader.readAsText(file);
    } else {
      notify(`File Format error`, "error", false, true);
      setLoading(false);
    }
  };
  const csvFileToArray = data => {
    data = data.replaceAll("\r\n", "\n");
    let csvHeader = data.slice(0, data.indexOf("\n")).split(",");
    let csvRows = data.slice(data.indexOf("\n") + 1).split("\n");

    csvHeader = csvHeader.filter(x => !!x).map(x => x.replaceAll(" ", "").toLowerCase());
    csvRows = csvRows.filter(x => !!x);
    if (headerValidate(csvHeader)) {
      notify(`File Header error`, "error", false, true);
      setLoading(false);
      return;
    }
    const createList = csvRows.map(i => {
      const values = i.split(",");
      const obj = csvHeader.reduce((object, header, index) => {
        const modelHeader: any = headers.find(x => x.toLowerCase() === header);
        object[modelHeader] = values[index];
        return object;
      }, {});
      return obj;
    });
    if (createList.length > 0) {
      createBulk(createList);
    } else {
      notify(`empty file`, "warning", false, true);
      setLoading(false);
    }
  };
  const createBulk = list => {
    dataProvider
      .createBulkAbilityControl(list)
      .then(result => {
        notify(`Successfully completed`, "success", false, true);
      })
      .catch(error => {
        notify(`Error, try again`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
        props?.refresh?.();
      });
  };
  const onSubmit = () => {};
  const base64toBlob = async () => {
    const bytes: any = atob(ExcelTemplate);
    let length = bytes?.length;
    let out = new Uint8Array(length);
    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }
    var blobData = new Blob([out], { type: ".xlsx" });
    const url = URL.createObjectURL(blobData);
    return url;
  };
  const handleDownload = async () => {
    const link = document.createElement("a");
    link.download = `AbilityTemplateFile.xlsx`;
    link.href = await base64toBlob();
    link.click();
  };
  return (
    <>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, form, values }) => {
          return (
            <form>
              <CustomLinearProgress loading={loading} periodTime={350} />
              <Card style={{ padding: "15px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={9}>
                    {" "}
                    <SectionTitle label="Create Ability Control with File" />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Button fullWidth startIcon={<CloudDownload />} onClick={handleDownload} color="primary">
                      Download Template
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider />
                    <Separator />
                    <FileInput
                      style={{ disabled: false }}
                      source="src"
                      label={"Bulk File Upload"}
                      options={{ onDrop: handleFileChange }}
                      RaFileInput={false}
                      accept=".csv,.xlsx,.msg,application/vnd.ms-outlook"
                    >
                      <FileField source="src" title="title" />
                    </FileInput>
                  </Grid>
                </Grid>
              </Card>
            </form>
          );
        }}
      />
    </>
  );
};

export default BulkUpload;
